import { UiModal } from 'components';
import { useEffect } from 'react';
import assign from 'lodash/assign';

import { useWidget, socket, identity } from 'widgets/lib';
import gift from 'widgets/functions/gift/gift';
import { hooks, debug, track } from 'lib';
import { useGlobalStore } from 'stores';
import { useBoolean } from 'react-hanger';
import roomLib from 'modules/widgets/lib/room';
import socketHandler from './socket-handler';
import adminList from './admin-list';
import uploader from './uploader';
import { getStore, useStore, useClientRoomStore } from '../store';
import giftBottom from './gift-bottom';
import { useRtc } from 'client/pc/lib/rtc-engine';

const useRoom = (roomId) => {
  const store = useStore();
  const { room, lianmai, users, topStars } = store;
  const { roomInfo, starInfo, liveType, isLive } = room;
  const {
    isLogin,
    isUserInfoReady,
    isGlobalPageConfigReady,
    userId,
    setSocketReady,
    setQtClientReady,
  } = useGlobalStore();

  const isReady = useBoolean(true);

  const isRoomOwner = userId === roomId;

  giftBottom.useUserList();

  useRtc();

  useWidget(roomId, store, {
    roomType: -1,
    isReady: isReady.value,
    initCar: false,
    initGift: true,
    initBag: false,
    initAuth: false,
    initMarquee: false,
    initSocketHandler: {
      initTplMsg: false,
      initEnter: true,
      initChat: true,
      initGift: true,
      initBroadcast: true,
      initAuth: true,
    },
  });

  hooks.useInterval(() => {
    debug.log('auto refresh room update', room);
    room.update();
  }, 1000 * 30);

  useEffect(() => {
    room.update();
    identity.formatUserData = (user) => {
      return assign({}, user, {
        // costTopIndex: MM.live.fans.getCostTopIndex(user._id),
        // isAdmin: MM.live.userList.isAdmin(user._id),
      });
    };
    // ------- guard.init();
    // sofa.init();
    lianmai.init();
    topStars.init();
    //
    //
    socketHandler.init();
    adminList.init();
    //
    //
    // gift.event.onBeforeSend = (data) => {
    //   return assign(data, {})
    // }
    //
    gift.isAnchorRoom = true;

    socket.event.onBeforeEmit = (action, msg, roomStore, widgetStore) => {
      return msg;
    };

    track.setExtraInfo({
      event: 'anchor',
      room_id: roomId,
      group_name: 'anchor',
      room_no: starInfo.mm_no,
    });

    track.send({
      event: 'page',
      event_type: 'pageClientAnchor',
      desc: '客户端个播房间',
    });

    return () => {
      setSocketReady(false);
    };
  }, [roomId]);
};

const getRoomId = () => {
  const { roomId } = getStore().room;
  return roomId;
};

const isHost = (uid) => {
  return false; // get(getStore(), 'room.roomInfo.host.uid') === uid
};

const useRoomCover = () => {
  const {
    room: { roomInfo },
  } = useClientRoomStore();
  useEffect(() => {
    console.log('useRoomCover', roomInfo?.audit_app_pic_status);
    // 未通过提示
    if (roomInfo?.audit_app_pic_status === 1) {
      UiModal.alert({
        title: '封面审核未通过',
        content: `${roomInfo?.audit_app_pic_reason}<br />
详细规范请参阅<a href="https://www.2339.com/notice/10134" class="text-primary" target="_blank">《封面上传规范指引》</a>。

`,
        cancelEnable: false,
        okText: '知道了',
      });
    }
  }, [roomInfo?.audit_app_pic_status]);
};

export { useRoom, getRoomId, isHost, useRoomCover };
